(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[532],{

/***/ 532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HeroText_HeroText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@storyblok/react/dist/storyblok-react.mjs
var storyblok_react = __webpack_require__(9036);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Cta/index.ts
var Cta = __webpack_require__(730);
// EXTERNAL MODULE: ./components/GridElement/index.ts
var GridElement = __webpack_require__(5299);
// EXTERNAL MODULE: ./components/GridWrapper/index.ts
var GridWrapper = __webpack_require__(2409);
// EXTERNAL MODULE: ./components/HeroText/HeroText.module.css
var HeroText_module = __webpack_require__(3233);
var HeroText_module_default = /*#__PURE__*/__webpack_require__.n(HeroText_module);
// EXTERNAL MODULE: ./node_modules/storyblok-rich-text-react-renderer/dist/index.es.js
var index_es = __webpack_require__(455);
;// CONCATENATED MODULE: ./components/HeroText/HeroText.tsx











var HeroText = function(param) {
    var blok = param.blok;
    var ref, ref1, ref2, ref3;
    var cta_link = blok.cta_link, cta_link_name = blok.cta_link_name, content = blok.content, content_text = blok.content_text, image = blok.image;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (HeroText_module_default()).heroText
    }, (0,storyblok_react/* storyblokEditable */.LF)(blok)), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridWrapper/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
                    className: (HeroText_module_default()).heroTextGridImg,
                    gridLayout: [
                        [
                            0,
                            1,
                            4,
                            1
                        ],
                        [
                            961,
                            6,
                            11,
                            1
                        ],
                        [
                            1401,
                            17,
                            16,
                            1
                        ], 
                    ],
                    children: (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroText_module_default()).heroTextBgImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image.filename,
                            alt: image.alt,
                            layout: "responsive",
                            width: 1000,
                            height: 1000,
                            objectFit: "cover"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GridElement/* default */.Z, {
                    className: (HeroText_module_default()).heroTextGridContent,
                    gridLayout: [
                        [
                            0,
                            1,
                            4,
                            1
                        ],
                        [
                            961,
                            5,
                            8,
                            1
                        ],
                        [
                            1401,
                            10,
                            14,
                            1
                        ], 
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroText_module_default()).heroTextContent,
                        children: [
                            content_text && (0,index_es/* render */.sY)(content_text, {
                                nodeResolvers: (_obj = {}, (0,_define_property/* default */.Z)(_obj, index_es/* NODE_PARAGRAPH */.e3, function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: children
                                    });
                                }), (0,_define_property/* default */.Z)(_obj, index_es/* NODE_UL */.mD, function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "pl-16 list-disc",
                                        children: children
                                    });
                                }), (0,_define_property/* default */.Z)(_obj, index_es/* NODE_OL */.iZ, function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                        className: "pl-16 list-decimal",
                                        children: children
                                    });
                                }), (0,_define_property/* default */.Z)(_obj, index_es/* NODE_LI */.wZ, function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "mb-6 last:mb-0",
                                        children: children
                                    });
                                }), (0,_define_property/* default */.Z)(_obj, index_es/* NODE_HEADING */.tw, function(children, props) {
                                    if ((props === null || props === void 0 ? void 0 : props.level) === 1) return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: children
                                    });
                                    if ((props === null || props === void 0 ? void 0 : props.level) === 2) return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: children
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: children
                                    });
                                }), _obj)
                            }),
                            content.length > 0 && content.map(function(p) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: p.content
                                }, p._uid);
                            }),
                            ((cta_link === null || cta_link === void 0 ? void 0 : (ref = cta_link.url) === null || ref === void 0 ? void 0 : ref.length) > 0 || (cta_link === null || cta_link === void 0 ? void 0 : (ref1 = cta_link.story) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.slug) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta/* default */.Z, {
                                href: cta_link === null || cta_link === void 0 ? void 0 : cta_link.url,
                                fullSlug: cta_link === null || cta_link === void 0 ? void 0 : (ref3 = cta_link.story) === null || ref3 === void 0 ? void 0 : ref3.full_slug,
                                name: cta_link_name,
                                style: {
                                    margin: "4rem auto 0"
                                }
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var HeroText_HeroText = (HeroText);

;// CONCATENATED MODULE: ./components/HeroText/index.ts



/***/ }),

/***/ 3233:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroText":"HeroText_heroText__nGbdP","heroTextBgImg":"HeroText_heroTextBgImg__fQqnt","heroTextContent":"HeroText_heroTextContent__b3QiI","heroTextGridImg":"HeroText_heroTextGridImg__WkqZG","heroTextGridContent":"HeroText_heroTextGridContent__E8chG"};

/***/ })

}]);